import React from "react";
import { KeyValue } from "../interfaces";
import IntermediaryDialog from "./IntermediaryDialog";

export default function LeavingFDICDialog({
  webAddress,
  label,
  toolTipText,
  noHover,
  sameWindow,
  bankName,
  condensedTooltip,
  content,
  button,
  closeRedirect,
  buttonProps,
  bold,
  styles,
}: {
  webAddress: string;
  label?: string;
  bankName?: string;
  toolTipText?: string;
  noHover?: boolean;
  sameWindow?: boolean;
  condensedTooltip?: boolean;
  content?: string | React.ReactElement;
  button?: boolean;
  closeRedirect?: string;
  buttonProps?: KeyValue;
  bold?: boolean;
  styles?: KeyValue;
}) {
  return (
    <IntermediaryDialog
      modalHeader="You are about to leave FDIC.gov"
      bold={bold}
      hoverText={
        noHover
          ? undefined
          : toolTipText
            ? toolTipText
            : webAddress?.toLowerCase()
      }
      content={
        content
          ? content
          : "The Primary Internet Web Addresses listed have been reported to the FDIC by each institution. The hyperlinks to institution Internet sites are provided solely as a convenience to users of the FDIC Internet site. The FDIC has made a limited effort to determine that these links function properly. However, linked sites are not under the control of FDIC, and FDIC is not responsible for the contents of any linked site, or any link contained in a linked site. Even if you access an institution's site by means of the link provided by FDIC, you are responsible for confirming the identity and authenticity of any institution you visit and transact business with online. The inclusion of a link does not imply or constitute an endorsement by FDIC of the institution, its ownership or management, the products or services it offers, or any advertisers or sponsors appearing on the institution's web site."
      }
      label={
        label ? label : webAddress?.toLowerCase().replace(/^https?:\/\//, "")
      }
      bankName={bankName}
      link={
        webAddress?.toLowerCase().startsWith("http")
          ? webAddress
          : `http://${webAddress}`
      }
      sameWindow={sameWindow}
      condensedTooltip={condensedTooltip}
      button={button}
      buttonProps={buttonProps}
      closeRedirect={closeRedirect}
      styles={styles}
    />
  );
}
